// extracted by mini-css-extract-plugin
export default {"contentido":"Home_contentido__W49tL"};